import { post } from '../index';

const verifyUsername = (body) => {
    return post(`/users/verify-username`, body);
};

export { verifyUsername };
